const ModalTitle = ({ className = "", ...props }) => (
  <div className={`mb-8 text-[2.5rem] font-semibold ${className}`.trim()} {...props} />
);

export default ModalTitle;
